module.exports = __webpack_public_path__ + "kp.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/1x1/kp.svg
// module id = 899
// module chunks = 0